import { useTranslation } from 'react-i18next'

import PersonalAddresses from '@widgets/personal/addresses/ui'

import Wrapper from '@shared/ui/wrapper'

import styles from './styles.module.scss'

export default function AddressesPage () {
  const { t: p } = useTranslation('personal')
  return (
    <div className={styles.root}>
      <Wrapper className={styles.root__wrapper}>
        <h2 className={styles.root__title}>{p('nav.addresses')}</h2>
        <PersonalAddresses />
      </Wrapper>
    </div>
  )
}
